module.exports = __webpack_public_path__ + "media/images/new_home/6-kiera-howell-1d550d6dcbe090949f8a8bc325803880.png";